import { EventsService } from 'api/event/service';
import { useCallback } from 'react';

export const useEvent = () => {
    const onGetAllEvent = useCallback(async () => {
        try {
            const response = await EventsService.getInstance().findAll();

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    const onGetOneEvent = useCallback(async (id: number) => {
        try {
            const response = await EventsService.getInstance().findOne(id);

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    return { onGetAllEvent, onGetOneEvent };
};
